import type { ReactNode } from 'react'
import { InMemoryProvider, OpenFeature, OpenFeatureProvider } from '@openfeature/react-sdk'
import {
  FF_PROVIDER_RESEARCH,
  userClientFlagConfig,
} from '../feature-flag.config'

type Props = {
  children: ReactNode
}

export function ResearchClientOpenFeatureProvider({ children }: Props) {
  const provider = new InMemoryProvider(userClientFlagConfig)
  OpenFeature.setProvider(FF_PROVIDER_RESEARCH, provider)

  return (
    <OpenFeatureProvider domain={FF_PROVIDER_RESEARCH}>
      {children}
    </OpenFeatureProvider>
  )
}
